import { Container } from 'react-bootstrap';
import '../../css/Content.css';
import 'bootstrap/dist/css/bootstrap.min.css'

export const Page1 = () => {




  return (
    <>      
      <div style={{paddingTop: '100px'}}>
        <div className="col-md-12 fontS-18" style={{color: '#000000'}}>
          <p>
            <strong>Apresentação</strong>
          </p>
          <p>
            Bem-vindos ao curso <strong>Procedimento de Gerenciamento de Mudança (Management of Change – MOC)</strong>. Vamos entender mais sobre o curso assistindo o vídeo a seguir.  
          </p>
          <br />
        </div>

        {/* Vídeo centralizado */}
        <div className="row justify-content-center" >
          <div className="col-md-10">
            <div
              style={{
                position: "relative",
                paddingBottom: "45.25%", // proporção 16:9
                height: 0,
                overflow: "hidden",
                borderRadius: "8px",
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/g78C5kcdJLE"
                title="Vídeo sobre Normas Técnicas - Acessível"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "90%",
                  borderRadius: "8px",
                }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page1;